import { useQuery } from 'react-query';
import api from '~services/ApiService';
import { SocialPulseResponse } from '~types/api/socialPulse';

export const useGetSocialPulse = () => {
  return useQuery<SocialPulseResponse, Error>(
    ['socialPulse'],
    async () => {
      return api.get<SocialPulseResponse>('/api/v1/social-pulse/current');
    },
    {
      staleTime: 300000, // 5 minutes
      cacheTime: 600000, // 10 minutes
    }
  );
};
